import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeFavorite } from '../../actions/favoriteEntities';
import { ResultsMobile } from '../../components/ResultsMobile';
import { IApplicationState } from '../../types/redux';

export const ResultsMobileContainer = () => {
  const results = useSelector((state: IApplicationState) => state.results);
  const page = useSelector((state: IApplicationState) => state.page);
  const user = useSelector((state: IApplicationState) => state.user);

  const dispatch = useDispatch();

  const handleClick = React.useCallback(
    (entityId: number) => {
      dispatch(removeFavorite({ entityId }));
    },
    [removeFavorite],
  );

  if (!results.favoriteEntities.length) {
    return null;
  }

  return <ResultsMobile results={results} page={page} user={user} removeFavorite={handleClick} />;
};
